var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 开关
 * @author (zhanghao14)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { noop, classPrefix } from '../../common/util';

import './Switch.less';

/**
 * 参数说明
 * className         可选，自定义样式类名
 * classPrefix       可选，类名前缀
 * type              可选，large 为大，small为小，默认为large, type 为small时不支持label
 * disabled          可选，是否禁用
 * readonly          可选，是否只读
 * checked           可选，是否打开
 * labels            可选，switch上显示的内容,其中on为打开时显示的文字，off为关闭时显示的文字
 * onClick           可选，被点击时触发
 */

var Switch = function (_Component) {
    _inherits(Switch, _Component);

    function Switch(props) {
        _classCallCheck(this, Switch);

        var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

        _this.state = {};
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(Switch, [{
        key: 'onClick',
        value: function onClick(e) {
            if (this.props.disabled || this.props.readOnly) {
                return;
            }
            e.target.value = !this.props.checked;
            this.props.onClick(e);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2, _classnames3;

            var _props = this.props,
                checked = _props.checked,
                className = _props.className,
                labels = _props.labels,
                classPrefix = _props.classPrefix,
                type = _props.type,
                disabled = _props.disabled,
                theme = _props.theme;

            var containerClassName = classnames((_classnames = {}, _defineProperty(_classnames, className, true), _defineProperty(_classnames, classPrefix + '-switch', true), _defineProperty(_classnames, classPrefix + '-switch-on', checked), _defineProperty(_classnames, classPrefix + '-switch-off', !checked), _defineProperty(_classnames, classPrefix + '-switch-disabled', disabled), _defineProperty(_classnames, classPrefix + '-switch-' + type, true), _defineProperty(_classnames, classPrefix + '-switch-theme-blue', theme === 'blue'), _classnames));
            var containerProp = {
                checked: checked,
                disabled: disabled,
                className: containerClassName,
                onClick: this.onClick
            };
            var label = checked && labels && labels.on ? labels.on : null;
            label = !checked && labels && labels.off ? labels.off : label;
            var labelClassName = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-switch-label', true), _defineProperty(_classnames2, classPrefix + '-switch-label-' + type, true), _classnames2));
            var cursorClassName = classnames((_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-switch-cursor', true), _defineProperty(_classnames3, classPrefix + '-switch-cursor-' + type, true), _classnames3));
            return React.createElement(
                'div',
                containerProp,
                React.createElement(
                    'div',
                    { className: labelClassName },
                    label
                ),
                React.createElement('div', { className: cursorClassName })
            );
        }
    }]);

    return Switch;
}(Component);

export default Switch;


Switch.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    type: 'large',
    disabled: false,
    classPrefix: classPrefix,
    // self
    readOnly: false,
    checked: false,
    labels: {
        on: 'ON',
        off: 'OFF'
    },
    onClick: noop,
    theme: 'green'
};

Switch.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    classPrefix: PropTypes.string,
    readOnly: PropTypes.bool,
    checked: PropTypes.bool,
    labels: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    theme: PropTypes.oneOf(['green', 'blue'])
};